import { FormErrors } from 'redux-form';
import { IEmitForm } from '../store/Emit';

const regexPhone = /^(9|2) [0-9]{4} [0-9]{4}$/i;
const regexAddress = /^[A-Za-zÀ-ÿÑñ0-9\-' ]+$/i;

const validation = (values: IEmitForm) => {
  const errors: FormErrors<any> = {};

  if (!values.phone) {
    errors.phone = 'Campo obligatorio';
  } else if (values.phone.replace(/ /gi, '').length < 9) {
    errors.phone = 'Teléfono inválido, debe contener 9 digitos';
  } else if (!['2', '9'].includes(String(values.phone)[0])) {
    errors.phone = 'El teléfono debe empezar por 9 o 2';
  } else if (!regexPhone.test(values.phone)) {
    errors.phone = 'El formato es incorrecto';
  }

  if (!values.address) {
    errors.address = 'Campo obligatorio';
  } else if (!regexAddress.test(values.address)) {
    errors.address =
      'La dirección no puede contener números ni caracteres especiales, solo letras y espacios';
  } else if (values.address.length > 130) {
    errors.address =
      'La dirección solo puede contener un máximo de 130 caracteres';
  }

  if (!values.addressNumber) {
    errors.addressNumber = 'Campo obligatorio';
  }

  if (!values.region) {
    errors.region = 'Campo obligatorio';
  }

  if (!values.province) {
    errors.province = 'Campo obligatorio';
  }

  if (!values.commune) {
    errors.commune = 'Campo obligatorio';
  }

  return errors;
};

export default validation;
